module.exports = {"370283001":"东阁街道","370283002":"李园街道","370283003":"同和街道","370283004":"凤台街道","370283005":"白沙河街道","370283101":"古岘镇","370283102":"仁兆镇","370283105":"南村镇","370283108":"蓼兰镇","370283109":"崔家集镇","370283110":"明村镇","370283113":"田庄镇","370283116":"新河镇","370283119":"店子镇","370283120":"大泽山镇","370283122":"旧店镇","370283124":"云山镇","370283400":"平度经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370283.json
// module id = 1491
// module chunks = 0